
document.addEventListener('DOMContentLoaded', () => {
  console.log(" API WAVE INIT 2.0 ");

  var divg = document.createElement("div");
  divg.appendChild(document.createTextNode(""));
  document.body.appendChild(divg).innerHTML = "<span id='result'></span>";

  var link = document.getElementById('result');
  link.parentNode.style.display = 'none'; //or
  link.parentNode.style.visibility = 'hidden';


});



function PAYMENT_API_POINT(montant, success_url, error_url, client_referenceI, restrict_payer_mobile, posted_id_client, DomaineClient, KeyIDClient, SecretIDClient, KeyPassCheckClient) {

  if (!isAlphaNumeric(client_referenceI) || !isAlphaNumeric(posted_id_client) || !isAlphaNumeric(KeyPassCheckClient)) {
    console.log("Erreur de formatage");
    console.warn("Erreur de TYPE CHAR FORMAT 084 ID_USER - KEYPASS - REFCLIENT");

  }
  else {

    var MaDateActuelle = new Date().getTime();

    var client_reference = client_referenceI + "_" + MaDateActuelle + "_" + posted_id_client;
    var mobiSize_W = 450;

    var wW = window.innerWidth;
    var wH = window.innerHeight;

    var mapForm = document.createElement("form");
    if (wW < mobiSize_W) {
      mapForm.target = "_self";
    }
    else {
      mapForm.target = "Map";
    }

    mapForm.method = "POST"; // or "post" if appropriate
    mapForm.action = "https://construireenbri.com/wave/int.wave";

    var mapInputmontant = document.createElement("input");
    mapInputmontant.type = "text";
    mapInputmontant.name = "montant";
    mapInputmontant.value = montant;
    mapForm.appendChild(mapInputmontant);

    var mapInputerror_url = document.createElement("input");
    mapInputerror_url.type = "text";
    mapInputerror_url.name = "error_url";
    mapInputerror_url.value = error_url;
    mapForm.appendChild(mapInputerror_url);

    var mapInputsuccess_url = document.createElement("input");
    mapInputsuccess_url.type = "text";
    mapInputsuccess_url.name = "success_url";
    mapInputsuccess_url.value = success_url;
    mapForm.appendChild(mapInputsuccess_url);

    var mapInputclient_reference = document.createElement("input");
    mapInputclient_reference.type = "text";
    mapInputclient_reference.name = "client_reference";
    mapInputclient_reference.value = client_reference;
    mapForm.appendChild(mapInputclient_reference);

    var mapInputrestrict_payer_mobile = document.createElement("input");
    mapInputrestrict_payer_mobile.type = "text";
    mapInputrestrict_payer_mobile.name = "restrict_payer_mobile";
    mapInputrestrict_payer_mobile.value = restrict_payer_mobile;
    mapForm.appendChild(mapInputrestrict_payer_mobile);

    var mapInputposted_id_client = document.createElement("input");
    mapInputposted_id_client.type = "text";
    mapInputposted_id_client.name = "posted_id_client";
    mapInputposted_id_client.value = posted_id_client;
    mapForm.appendChild(mapInputposted_id_client);

    var mapInputDomaineClient = document.createElement("input");
    mapInputDomaineClient.type = "text";
    mapInputDomaineClient.name = "DomaineClient";
    mapInputDomaineClient.value = DomaineClient;
    mapForm.appendChild(mapInputDomaineClient);

    var mapInputKeyClient = document.createElement("input");
    mapInputKeyClient.type = "text";
    mapInputKeyClient.name = "KeyClient";
    mapInputKeyClient.value = KeyIDClient;
    mapForm.appendChild(mapInputKeyClient);

    var mapInputSecretClient = document.createElement("input");
    mapInputSecretClient.type = "text";
    mapInputSecretClient.name = "SecretClient";
    mapInputSecretClient.value = SecretIDClient;
    mapForm.appendChild(mapInputSecretClient);

    var mapInputKeyPassCheckClient = document.createElement("input");
    mapInputKeyPassCheckClient.type = "text";
    mapInputKeyPassCheckClient.name = "KeyPassCheckClient";
    mapInputKeyPassCheckClient.value = KeyPassCheckClient;
    mapForm.appendChild(mapInputKeyPassCheckClient);
    //console.log("**************** H:"+wH+" - W:"+wW+"*************");

    //document.body.appendChild(mapForm);
    document.getElementById("result").appendChild(mapForm);

    if (wW < mobiSize_W) {
      map = window.open("", "_self");

      if (map) {
        mapForm.submit();
        map.addEventListener("beforeunload", function (e) {

        });

        const interval = setInterval(() => {
          if (map.closed) {
            clearInterval(interval);
            ////////////////////////console.log('> Popup Closed');
            clearInterval(waitInterval);
            ///////////////////////////console.log("Stop Checking payment");
            // window.location.reload();
          }
        }, 500);


        main(map, client_reference, montant, success_url, DomaineClient);
      } else {
        alert('Vous devez autoriser les popups afin que cette page fonctionne correctement');
      }



    }
    else {


      map = window.open("", "Map", "status=0,title=0,height=800,width=800,scrollbars=1");

      if (map) {
        mapForm.submit();
        map.addEventListener("beforeunload", function (e) {
          ///////////////////////////console.log("+++++ START ++++++ ");
          e.preventDefault();
          e.returnValue = '';
        });

        const interval = setInterval(() => {
          if (map.closed) {
            clearInterval(interval);
            ///////////////////////////console.log('> Popup Closed');
            clearInterval(waitInterval);
            //////////////////////////////console.log("Stop Checking payment");
            // window.location.reload();
          }
        }, 500);


        main(map, client_reference, montant, success_url, DomaineClient);
      } else {
        alert('Vous devez autoriser les popups afin que cette page fonctionne correctement');
      }
    }


  }

}

function APIloadURL(url) {
  location.replace(url);
}

function wait(seconds, map, id, montant, success_url, domaine) {
  waitInterval = setInterval(() => {
    ApiCheckPaymentStatut(map, id, montant, success_url, domaine);
    //////////////////console.log("Check WAVE API payment");
  }, seconds * 1000);

}

async function main(map, id, montant, success_url, domaine) {
  ////////////////////////////////////////console.log("Start");
  await wait(1, map, id, montant, success_url, domaine); // Wait for 5 seconds
  console.log("++++ Main Wave API System ++++");

}



async function ApiCheckPaymentStatut(map, id, montant, success_url, domaine) {
  var key = window.location.hostname;
  var app_url_server = "https://construireenbri.com/";
  var Postdata = { "st_via": "" + key + "", "dfdx": "dds" };
  //fetch(app_url_server+`ajax/client/paiement_api.php?req=apiCheckup&token_api_client=${key}&ref=${id}&montant=${montant}`,{ method: "POST",mode: 'no-cors',credentials: 'include',headers: {'Content-Type': 'application/json','API-Key': 'secret','Access-Control-Allow-Origin':'*','Access-Control-Allow-Credentials':'true','Access-Control-Allow-Methods':'GET,OPTIONS,PATCH,DELETE,POST,PUT', 'Access-Control-Allow-Headers':'Origin,X-CSRF-Token, X-Requested-With, Accept, Accept-Version, Content-Length, Content-MD5, Content-Type, Date, X-Api-Version, Authorization'} ,body: JSON.stringify(Postdata) })
  //,mode: 'no-cors'
  fetch(app_url_server + `ajax/client/paiement_api.php?req=apiCheckup&token_api_client=${key}&ref=${id}&montant=${montant}`, { method: "POST", mode: 'no-cors', headers: { "Content-Type": "application/x-www-form-urlencoded", 'Access-Control-Allow-Origin': 'https://client.edengroup.net/', 'Access-Control-Allow-Credentials': 'true', 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT', 'Access-Control-Allow-Headers': 'Origin,X-CSRF-Token, X-Requested-With, Accept, Accept-Version, Content-Length, Content-MD5, Content-Type, Date, X-Api-Version, Authorization' }, body: JSON.stringify(Postdata) })
    .then(response => {
      if (!response.ok) {
        ///statusText
        throw new Error(response.status)
      }
      return response.json();

    })
    .catch(error => {
      Swal.showValidationMessage(`Erreur : ${error}`)

    }).then((result) => {
      var ResultatStatut = result.STATUT_OPR;


      if (ResultatStatut == "YES") {
        clearInterval(waitInterval);
        APIloadURL(result.successUrl);
        map.close();
      } else if (ResultatStatut == "NO") {
        clearInterval(waitInterval);
        APIloadURL(result.errorUrl);
        map.close();
      }
      else {
        console.log(result.EVENT);
      }

    })


}

function isAlphaNumeric(str) {
  var code, i, len;

  for (i = 0, len = str.length; i < len; i++) {
    code = str.charCodeAt(i);
    if (!(code > 47 && code < 58) && // numeric (0-9)
      !(code > 64 && code < 91) && // upper alpha (A-Z)
      !(code > 96 && code < 123)) { // lower alpha (a-z)
      return false;
    }
  }
  return true;
};

//https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser

